import { c } from 'ttag';

import { refusalCode } from '../../graphql/refusalCode';
import { Refusal } from './portalAccess';

// An empty portfolio is not a refusal: it comes back as an empty page, total zero.
export const accountsRefusalOf = (error: unknown): Refusal => {
    switch (refusalCode(error)) {
        case 'MISSING_PERMISSION':
            return {
                title: c('Accounts refusal').t`Your role does not let you manage accounts.`,
                guidance: c('Accounts refusal')
                    .t`This list is gated by the very permission its gestures need, so that nobody lands on a screen where everything refuses. The list was refused, not answered: this is not a portfolio with no account in it. Ask an administrator for that permission.`,
            };
        case 'INTERNAL_STAFF_ONLY':
            return {
                title: c('Accounts refusal').t`This screen belongs to the back-office.`,
                guidance: c('Accounts refusal')
                    .t`Listing client accounts in order to configure them is a Freelance.com decision, so a client-side role cannot carry it whatever its permissions, otherwise an account would configure itself. The scope of the role is checked before the permission, which is why a custom role holding the right is refused too.`,
            };
        case 'NO_ACTIVE_MEMBERSHIP':
            return {
                title: c('Accounts refusal').t`Your session carries no active membership.`,
                guidance: c('Accounts refusal')
                    .t`Your identity is recognised but it is attached to nothing right now, so there is no perimeter to read the accounts through. Sign in again; if it happens once more, your own access has to be reopened.`,
            };
        case 'NOT_AUTHENTICATED':
            return {
                title: c('Accounts refusal').t`Your session is no longer valid.`,
                guidance: c('Accounts refusal').t`Sign in again, then open this list back.`,
            };
        default:
            return {
                title: c('Accounts refusal').t`The list of accounts could not be read.`,
                guidance: c('Accounts refusal')
                    .t`This refusal is not one the screen knows how to read, so nothing here says what to do about it. Above all it does not say that your perimeter is empty: nothing was counted. The server's answer is below; it is what the support desk needs.`,
                detail: error instanceof Error ? error.message : String(error),
            };
    }
};

// Not a subset of the list above: this query carries no permission check, so
// MISSING_PERMISSION and INTERNAL_STAFF_ONLY cannot come out of it.
export const accountLookupRefusalOf = (error: unknown): Refusal => {
    switch (refusalCode(error)) {
        case 'NO_ACTIVE_MEMBERSHIP':
            return {
                title: c('Accounts refusal').t`Your session carries no active membership.`,
                guidance: c('Accounts refusal')
                    .t`Your identity is recognised but it is attached to nothing right now, so there is no perimeter to look this account up in. Sign in again; if it happens once more, your own access has to be reopened.`,
            };
        case 'NOT_AUTHENTICATED':
            return {
                title: c('Accounts refusal').t`Your session is no longer valid.`,
                guidance: c('Accounts refusal').t`Sign in again, then open this account back.`,
            };
        default:
            return {
                title: c('Accounts refusal').t`This account could not be read.`,
                guidance: c('Accounts refusal')
                    .t`Its name and its portal access are read through the list of the accounts you may act on, and that read failed. So nothing below describes this account, and its absence here does not mean it is outside your perimeter. The server's answer is below.`,
                detail: error instanceof Error ? error.message : String(error),
            };
    }
};
